export const logOutText = {
  ConfirmationText: {
    en: "Confirm logout",
    mr: "लॉगआउटची पुष्टी करा",
  },
  Message: {
    en: "Are you sure you want to log out?",
    mr: "तुम्हाला नक्की लॉगआउट करायचे आहे का?",
  },
  No: {
    en: "No",
    mr: "नाही",
  },
  Yes: {
    en: "Yes",
    mr: "होय",
  },
};
